import { axiosEduServer } from "../utils/configAxios";

export const crearPrograma = (data) => {
  return axiosEduServer.post('/programa', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarPrograma = (id, data) => {
  return axiosEduServer.put(`/programa/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarPrograma = (id) => {
  return axiosEduServer.delete(`/programa/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOnePrograma = (id) => {
  return axiosEduServer.get(`/programa/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllProgramas = () => {
  return axiosEduServer.get('/programa').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllProgramasByIdIdioma = (idIdioma) => {
  return axiosEduServer.get(`/programa/ididioma/${idIdioma}`).then(({ data }) => data).catch((err) => { throw err });
};